function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_4614_115367)"
}, React.createElement("path", {
  d: "M10.0007 3.19949C8.4364 3.56213 6.99761 4.33669 5.83358 5.44283C4.66954 6.54897 3.82264 7.9464 3.38072 9.49017C2.93881 11.0339 2.91798 12.6678 3.32039 14.2224C3.72279 15.7769 4.53378 17.1955 5.66924 18.3309C6.8047 19.4664 8.22327 20.2774 9.77781 20.6798C11.3323 21.0822 12.9662 21.0614 14.51 20.6195C16.0538 20.1776 17.4512 19.3307 18.5574 18.1666C19.6635 17.0026 20.4381 15.5638 20.8007 13.9995C20.8007 13.7343 20.6953 13.4799 20.5078 13.2924C20.3203 13.1049 20.0659 12.9995 19.8007 12.9995H13.0007C12.4703 12.9995 11.9616 12.7888 11.5865 12.4137C11.2114 12.0386 11.0007 11.5299 11.0007 10.9995V3.99949C10.9883 3.88102 10.9525 3.76619 10.8953 3.66166C10.8382 3.55714 10.7608 3.46499 10.6678 3.39058C10.5748 3.31616 10.4679 3.26095 10.3534 3.22815C10.2389 3.19535 10.119 3.18561 10.0007 3.19949Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M15 3.5C16.2697 3.94708 17.423 4.6733 18.3748 5.62516C19.3267 6.57702 20.0529 7.73028 20.5 9H16C15.7348 9 15.4804 8.89464 15.2929 8.70711C15.1054 8.51957 15 8.26522 15 8V3.5Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_4614_115367"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgIconShowChartDark = function SvgIconShowChartDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconShowChartDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_show_chart_dark.3de985c1.svg";
export { ForwardRef as ReactComponent };